import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-client-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.scss']
})
export class ClientLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
